import { render, staticRenderFns } from "./AlignInput.vue?vue&type=template&id=491888df"
import script from "./AlignInput.vue?vue&type=script&lang=js"
export * from "./AlignInput.vue?vue&type=script&lang=js"
import style0 from "./AlignInput.vue?vue&type=style&index=0&id=491888df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports